import { Resources } from '@shared/localizations/Resources';
import { AccountSeal } from './Account.types';
export function getAccountModeText(account) {
    const accountMode = account.getMode();
    switch (accountMode) {
        case AccountSeal.Demo:
            return Resources.getResource('Accounts.AccountDetails.Mode.Demo');
        case AccountSeal.Live:
            return Resources.getResource('Accounts.AccountDetails.Mode.Live');
        case AccountSeal.Contest:
            return Resources.getResource('Accounts.AccountDetails.Mode.Contest');
        case AccountSeal.Funded:
            return Resources.getResource('Accounts.AccountDetails.Mode.Funded');
        case AccountSeal.Challenge:
            return Resources.getResource('Accounts.AccountDetails.Mode.Challenge');
    }
    return Resources.getResource('Accounts.AccountDetails.Mode.Demo');
}
export function getAccountModeStyle(account) {
    const accountMode = account.getMode();
    switch (accountMode) {
        case AccountSeal.Demo:
            return 'Demo';
        case AccountSeal.Live:
            return 'Live';
        case AccountSeal.Contest:
            return 'Contest';
        case AccountSeal.Funded:
            return 'Funded';
        case AccountSeal.Challenge:
            return 'Challenge';
        default:
            return 'Demo';
    }
}
export function getAccountModeWidth(account) {
    const accountMode = account.getMode();
    switch (accountMode) {
        case AccountSeal.Demo:
        case AccountSeal.Live:
            return 32;
        case AccountSeal.Contest:
            return 39;
        case AccountSeal.Funded:
            return 37;
        case AccountSeal.Challenge:
            return 49;
        default:
            return 32;
    }
}
